module.exports = __webpack_public_path__ + "img/color_01.43283824.jpg";